import { FC } from 'react';

import { cn, useWindowWidth } from '@distribute/frontend/utils';

import { Player } from '@distribute/frontend/ui/player';

import { VideoCardFailed } from './VideoCardFailed';
import { VideoCardLoading } from './VideoCardLoading';

type Props = {
  size?: 'sm' | 'md';
  isFailed?: boolean;
  isLoading?: boolean;
  url: string;
  posterUrl: string;
  aspectRatio: string;
  className?: string;
  hideBanner?: boolean;
};

export const VideoPlayer: FC<Props> = ({
  size,
  isFailed = false,
  isLoading = false,
  url,
  posterUrl,
  aspectRatio,
  className,
  hideBanner = false,
}) => {
  const { isMobile } = useWindowWidth();
  const _size = size ?? (isMobile ? 'sm' : 'md');

  return (
    <div
      style={{ aspectRatio }}
      className={cn(
        'overflow-hidden',
        { 'rounded-lg border border-base-black/[0.08]': !isMobile },
        className
      )}
    >
      {isLoading ? (
        <VideoCardLoading size={_size} />
      ) : isFailed ? (
        <VideoCardFailed size={_size} />
      ) : (
        <Player
          url={url}
          posterUrl={posterUrl}
          aspectRatio={aspectRatio}
          hotKeys
          removeDownloadOverlay={hideBanner}
        />
      )}
    </div>
  );
};
